import templateUrl from './operation-info.html';
import zipObject from 'lodash/zipObject';
import findIndex from 'lodash/findIndex';

export const operationInfoComponent = {
	bindings: {
		details: '<',
		onSubmit: '&',
		onCancel: '&',
		onPrevious: '&',
		showNextButton: '@',
		showPreviousButton: '@',
		prevDetails: '<',
		newDetails: '<',
		parentSlug: '@'
	},

	templateUrl,
	
	controller: class OperationInfoComponent {
		constructor($state, $parse, CompareObjectService, ModalService) {
			'ngInject';

			this.$state = $state;
			this.$parse = $parse;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
		}

		$onInit() {
			this.errorMsg = '';
			this._showNextButton = this.$parse(this.showNextButton || 'true')(true);
			this._showPreviousButton = this.$parse(this.showPreviousButton || 'true')(true);
			this.details = this.details || {
				hoursOfOperation: {
					startTime: '',
					endTime:'',
					isAllDay: false
				},
				daysOfOperation: ''
			};

			this.daysOfOperation = this.details.daysOfOperation || [
				{
					id: 1,
					displayName: 'Mon',
					name: 'monday',
					isSelected: false
				},
				{
					id: 2,
					displayName: 'Tue',
					name: 'tuesday',
					isSelected: false
				},
				{
					id: 3,
					displayName: 'Wed',
					name: 'wednesday',
					isSelected: false
				},
				{
					id: 4,
					displayName: 'Thu',
					name: 'thursday',
					isSelected: false
				},
				{
					id: 5,
					displayName: 'Fri',
					name: 'friday',
					isSelected: false
				},
				{
					id: 6,
					displayName: 'Sat',
					name: 'saturday',
					isSelected: false
				},
				{
					id: 7,
					displayName: 'Sun',
					name: 'sunday',
					isSelected: false
				}
			];

			this.hoursOfOperation = {
				range: {
					startTime: {
						title: 'start time',
						selectedTime: this.details.hoursOfOperation.startTime || new Date()
					},
					endTime: {
						title: 'end time',
						selectedTime: this.details.hoursOfOperation.endTime || new Date()
					}
				}
			}

			if(this.details.hoursOfOperation.isAllDay) {
				this.hoursOfOperation.range.startTime.isDisabled = true;
				this.hoursOfOperation.range.endTime.isDisabled = true;
			} else {
				this.hoursOfOperation.range.startTime.isDisabled = false;
				this.hoursOfOperation.range.endTime.isDisabled = false;
			}
		}

		onChange(items) {
			this.details.daysOfOperation = items;
		}

		onAllDayCheckboxSelected() {
			if(this.details.hoursOfOperation.isAllDay) {
				this.hoursOfOperation.range.startTime.isDisabled = true;
				this.hoursOfOperation.range.endTime.isDisabled = true;
			} else {
				this.hoursOfOperation.range.startTime.isDisabled = false;
				this.hoursOfOperation.range.endTime.isDisabled = false;
			}
		}

		_onCancel() {
			this.saveData = angular.copy(this.prevDetails);
			const _details = angular.copy(this.newDetails);
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

			if(isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
	
					buttons: [
						{
							name: 'No'
						},
						{
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}
					]
				});
			} else {
				this._redirectToParentState(this.parentSlug);
			}

			function onSubmit() {
				this._redirectToParentState(this.parentSlug);
			}
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}

		_onSubmit() {
			this.details.hoursOfOperation.startTime = this.hoursOfOperation.range.startTime.selectedTime;
			this.details.hoursOfOperation.endTime = this.hoursOfOperation.range.endTime.selectedTime;
			let index = findIndex(this.details.daysOfOperation, 'isSelected');
			if(index !== -1) {
				this.errorMsg = '';
				this.onSubmit({
					$event: {
						operationInfo: this.details
					}
				});
			} else {
				this.errorMsg = 'This field is required';
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/operation-info/operation-info.component.js